<div>
    <h1 mat-dialog-title>Thank You for Upgrading</h1>
    <div mat-dialog-content>
        <p>
            You have successfully upgraded your workspace. From the Admin Dashboard in your
            workspace, you will be able to add or remove users as well as add more storage if
            needed.
        </p>
        <p>
            We are eager to help you with any issues or questions you may have and as always, we
            welcome any and all feedback. Feel free to email us at
            <a href="mailto:help@frogeye.io">help&#64;frogeye.io</a>
        </p>
        <p>
            You can also visit our discord if you have any questions or issues,
            <a href="https://discord.gg/WHgwEshATM">https://discord.gg/WHgwEshATM</a>
        </p>
    </div>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close>Close</button>
    </div>
</div>
